module.exports = __webpack_public_path__ + "static/media/referrals-sm.5db2e517.png";